<template>
	<section class="max-full" v-if="data && data.image">
		<WpImage :image="data.image" size="extra_large" class="image" background cover />
	</section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'

export default {
	name: 'banner-image',
	props: ['data'],
	computed: {},
	components: {
		WpImage,
	},
}
</script>

<style lang="scss">
.module-banner_image {
	max-width: 2500px;
	margin-left: auto;
	margin-right: auto;
	.wp-image-vue.background .image {
		padding-bottom: 34.72%;
		min-height: 250px;
	}
}
</style>
